/** Where the invitation page lives. The token is in the URL fragment: never sent to a server. */
export function joinUrl(token: string): string {
  return `${window.location.origin}/join#${token}`;
}
